import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { StripePlugin } from "@vue-stripe/vue-stripe";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBell, faBookmark } from "@fortawesome/free-regular-svg-icons";
import {
  faUserCircle,
  faSearch,
  faArrowRight,
  faChevronRight,
  faChevronDown,
  faHashtag,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMeta from "vue-meta";
import Vuelidate from "vuelidate";
import VueJWT from "vuejs-jwt";
import VueTelInput from "vue-tel-input";
import Vue2Editor from "vue2-editor";
import "vue-tel-input/dist/vue-tel-input.css";

import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-2";



import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
var VueScrollTo = require("vue-scrollto");

//Axios
import Axios from "axios";
Vue.prototype.$http = Axios;
Vue.prototype.$http.defaults.headers.common["Device-Referrer-Id"] =
  process.env.VUE_APP_DEVICE_ID;
const accessToken = localStorage.getItem("culture_token");

if (accessToken) {
  Vue.prototype.$http.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${accessToken}`;
}

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

var AddToCalendar = require("vue-add-to-calendar");
Vue.use(AddToCalendar);

Vue.config.productionTip = false;
library.add(
  faBell,
  faUserCircle,
  faSearch,
  faBookmark,
  faArrowRight,
  faChevronDown,
  faChevronRight,
  faHashtag,
  faTruck
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(require("vue-moment"));

var VueTruncate = require("vue-truncate-filter");
Vue.use(VueTruncate);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueScrollTo);
Vue.use(Vuelidate);
Vue.use(VueJWT);
Vue.use(Vue2Editor);
Vue.use(VueTelInput);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(TawkMessengerVue, {
  propertyId: "636a6577daff0e1306d65cd1",
  widgetId: "1ghbpon9s",
});

const options = {
  pk: process.env.VUE_APP_STRIPE_TEST,
  stripeAccount: process.env.STRIPE_ACCOUNT,
  apiVersion: process.env.API_VERSION,
  locale: process.env.LOCALE,
};
Vue.use(StripePlugin, options);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAMKyUFXHFzrbI0cH8eGtpf3vz_7S0psyw",
    libraries: "places",
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
